import { render, staticRenderFns } from "./NewCustomerFeedback.vue?vue&type=template&id=2a108d48"
import script from "./NewCustomerFeedback.vue?vue&type=script&lang=js"
export * from "./NewCustomerFeedback.vue?vue&type=script&lang=js"
import style0 from "./NewCustomerFeedback.vue?vue&type=style&index=0&id=2a108d48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports